import { QuestionIcon } from 'foundations-assets/icons/components/QuestionIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { Small } from 'foundations-components/transitional/components/Small';
import { getFileUploadErrorMessage } from '../utils';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useHasNoUploadLimit } from '../../v2/hooks/useHasNoUploadLimit';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { View } from 'foundations-components/transitional/components/View';
import FileIconWrapper from '../FileIconWrapper';
import FileItemLayout from '../components/FileItemLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FileDraftErrorsListItem = ({
  file,
  errorType,
  onRemove
}) => {
  const hasNoUploadLimit = useHasNoUploadLimit();
  const tooltip = getFileUploadErrorMessage(errorType, hasNoUploadLimit);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "50",
      children: /*#__PURE__*/_jsx(FileItemLayout, {
        variant: "error",
        "data-test-id": "file-attachment-with-error",
        icon: /*#__PURE__*/_jsx(QuestionIcon, {
          size: "400"
        }),
        labelContent: file.name,
        actions: /*#__PURE__*/_jsx(FileIconWrapper, {
          children: /*#__PURE__*/_jsx(IconButton, {
            size: "small",
            use: "link",
            onClick: () => onRemove(file),
            "data-test-id": "file-attachment-with-error-remove-icon",
            children: /*#__PURE__*/_jsx(RemoveIcon, {
              size: "100"
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx(TruncateString, {
      tooltip: tooltip,
      children: /*#__PURE__*/_jsx(Small, {
        use: "error",
        weight: "medium",
        children: tooltip
      })
    })]
  });
};
export default FileDraftErrorsListItem;